import React from 'react';
import { render } from 'react-dom';
import { RecoilRoot } from 'recoil';

import App from './App';

render(
  <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);
